import { canEditByRoute } from '@/utils'
import _ from 'lodash'
import { App } from 'vue'

export default {
  install(app: App) {
    app.mixin({
      data() {
        return {
          /**
           * 私有变量，禁止访问
           */
          // eslint-disable-next-line vue/no-reserved-keys
          __privateVariable: {
            canEditResolved: false,
          },
        }
      },
      computed: {
        /**
         * 从环境变量读取 API请求的基础路径地址
         * @returns
         */
        baseURL() {
          return process.env.VUE_APP_BASEURL || ''
        },
      },
    })
  },
}
